import { APP_TOKEN_STORAGE_KEY, IMPERSONATION_ORIGIN_STORAGE_KEY } from '../constants';

let appTokenSource: (() => string | null) | null = null;

/**
 * Registers where the app token comes from — `MtmAuthBridgeService.getAppTokenSync()`, wired once at
 * bootstrap by `provideMtmAuth()`. Kept as a plain function so code outside Angular DI (models, helpers,
 * header builders) reads the same token as the interceptors, through the SDK rather than a storage key.
 */
export function registerAppTokenSource(source: () => string | null): void {
  appTokenSource = source;
}

/**
 * The current app token, read through the IAM SDK.
 *
 * During an admin "switch user", the gateway switch-user token lives only in `localStorage['app_token']` (the
 * SDK knows nothing about it), so that key is returned instead. Before bootstrap registers the SDK source,
 * the key is read directly.
 */
export function currentAppToken(): string | null {
  if (isImpersonationActive() || appTokenSource === null) {
    return localStorage.getItem(APP_TOKEN_STORAGE_KEY);
  }
  return appTokenSource();
}

export function isImpersonationActive(): boolean {
  return !!localStorage.getItem('admin_token') || !!localStorage.getItem(IMPERSONATION_ORIGIN_STORAGE_KEY);
}
